import { CmsLink, CroppedImage, KeyValue } from '../..'

interface cinema {
    nodeId: number
    name: string
    url: string
}

export interface RegionalAnnouncementExtension {
    startDateTime: string
    endDateTime: string
    promotionName: string
    message: string
    cinemas: cinema[]
}

export const mapRegionalAnnouncement = ( data: RegionalAnnouncementExtension, attributesData: KeyValue[] ): RegionalAnnouncementExtension => {
    return data
}
